import { Injectable }  from '@angular/core';
import * as jwt_decode from 'jwt-decode';
import { zip } from 'rxjs';

import { DataService } from './user-detail.service';
import { LoginService } from './login/shared/login.service';
import { StaffService } from './shared/services/staff.service';
import { environment } from './../environments/environment';

@Injectable()
export class AppInitService {
    authURL = `${environment.AUTH_URL}/home?action=issue&redirectUrl=${environment.REDIRECT_URL}&appName=attendance`;
    constructor(
        private dataService: DataService,
        private loginService: LoginService,
        private staffService: StaffService) {
    }
    
    Init() {
        console.log('AMS init service');
        // create iframe for login server
        let newIframe = document.createElement('IFRAME');
        newIframe.id = 'login-system';
        newIframe.style.display = "none";
        (<HTMLIFrameElement>newIframe).src = `${environment.AUTH_URL}/standby` ;
        document.body.appendChild(newIframe);
 
        return new Promise<void>((resolve, reject) => {
            // when iframe is finish loading
            newIframe.onload = async (e) => {
                const token = localStorage.getItem('access_token');
                if(!token) {
                    setTimeout(() => { resolve(); }, 50);
                    return;
                }
                // let res = await this.loginService.validateToken().toPromise();
                this.loginService.validateToken().subscribe(
                    (res) => {
                        if (!res.data && res.message == '401') {
                            localStorage.removeItem('access_token')
                            resolve();
                        } else {
                            let data = jwt_decode(token);
                            let staffId = data._id;
                            zip(
                                this.staffService.getStaffById(staffId),
                                this.loginService.getAttendanceSetting(staffId),
                            ).subscribe(res => {
                                this.dataService.setStaffInfo = res[0].data;
                                this.dataService.setIndividualSettings = res[1];

                                // if there's a settings returned, set hasSettings.
                                if (res[1]) {
                                    this.dataService.setHasSettings = true;
                                }
                                resolve();
                            })
                        }
                    }
                )
                
            }
        });
    }
}